import { StructureObjectField } from '../../enums/structure-object';

import titleIcon from '../../../images/icons/structure-object/text-icon.svg';
import usersIcon from '../../../images/icons/structure-object/users-icon.svg';
import amountIcon from '../../../images/icons/structure-object/amount-icon.svg';
import companyIcon from '../../../images/icons/structure-object/company-icon.svg';
import clockIcon from '../../../images/icons/structure-object/oclock-icon.svg';
import descIcon from '../../../images/icons/structure-object/description-icon.svg';
import financeIcon from '../../../images/icons/structure-object/finance-icon.svg';
import userIcon from '../../../images/icons/structure-object/user-icon.svg';
import priorityIcon from '../../../images/icons/structure-object/priority-icon.svg';
import stageIcon from '../../../images/icons/structure-object/stage-icon.svg';
import taskIcon from '../../../images/icons/dark/tasks-icon.svg';
import sellingIcon from '../../../images/icons/dark/sellings-icon.svg';

export const structureProject: StructureObjectField[] = [
    {
        key: 'name',
        label: 'Назва',
        order: 1,
        icon: titleIcon,
        visible: true,
        isRequired: true,
    },
    {
        key: 'contactEmail',
        label: 'Контакт',
        order: 2,
        icon: usersIcon,
        visible: true,
        isRequired: true,
    },
    {
        key: 'budget',
        label: 'Бюджет',
        order: 3,
        icon: amountIcon,
        visible: true,
        isRequired: true,
    },
    {
        key: 'companyName',
        label: 'Компанія',
        order: 4,
        icon: companyIcon,
        visible: true,
    },
    {
        key: 'createdAt',
        label: 'Дата початку',
        order: 6,
        icon: clockIcon,
        visible: true,
    },
    {
        key: 'deadline',
        label: 'Дата закінчення',
        order: 5,
        icon: clockIcon,
        visible: true,
        isRequired: true,
    },
    {
        key: 'description',
        label: 'Опис',
        order: 7,
        icon: descIcon,
        visible: true,
    },
    {
        key: 'responsibleEmail',
        label: 'Відповідальний контакт',
        order: 8,
        icon: userIcon,
        visible: true,
        isRequired: true,
    },
    {
        key: 'priorityName',
        label: 'Пріорітет',
        order: 9,
        icon: priorityIcon,
        visible: true,
        isRequired: true,
    },
    {
        key: 'projectStageName',
        label: 'Етап проєкту',
        order: 10,
        icon: stageIcon,
        visible: true,
        isRequired: true,
    },
    {
        key: 'author',
        label: 'Автор',
        order: 11,
        icon: userIcon,
        visible: true,
    },
];

export const structureProjectOther: StructureObjectField[] = [
    {
        key: 'team-members',
        label: 'Учасники проєкту',
        order: 1,
        icon: usersIcon,
        visible: true,
        isRequired: true,
    },
    {
        key: 'allIncome',
        label: 'Надходження',
        order: 2,
        icon: financeIcon,
        visible: true,
    },
    {
        key: 'allExpense',
        label: 'Витрати',
        order: 3,
        icon: financeIcon,
        visible: true,
    },
    {
        key: 'tasks',
        label: 'Завдання',
        order: 4,
        icon: taskIcon,
        visible: true,
    },
    {
        key: 'selling',
        label: 'Продажі',
        order: 5,
        icon: sellingIcon,
        visible: true,
    },
]